import React from "react";
import "./../../index.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <h2>
        Developed by :{" "}
        <a
          href="https://www.linkedin.com/in/ali-nasir-04158817a/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Ali Nasir
        </a>{" "}
      </h2>
    </div>
  );
};

export default Footer;
